﻿// assets
import { 
  DashboardOutlined, 
  BarChartOutlined, 
  LineChartOutlined, 
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined,
  CloudUploadOutlined,
  ToolOutlined
} from '@ant-design/icons';
import { openSpectraImportDialog } from '../pages/spectra/spectraimport';

// icons
const icons = {
  DashboardOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined,
  CloudUploadOutlined,
  ToolOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Spectra',
  titleKey: 'menu.groups.spectra',
  titleVariant: 'h6',
  titleSx: { fontSize: 15, fontWeight: 700 },
  type: 'group',
  icon: icons.LineChartOutlined,

  children: [
    {
      id: 'spectraviewer',
      title: 'Spectra Viewer',
      titleKey: 'menu.items.spectraViewer',
      type: 'item',
      icon: icons.LineChartOutlined,
      url: '/spectra/spectraviewer',
      breadcrumbs: false
    },
    {
      id: 'spectraimport',
      title: 'Spectra Import',
      titleKey: 'menu.items.spectraImport',
      type: 'item',
      icon: icons.CloudUploadOutlined,
      action: openSpectraImportDialog,
      breadcrumbs: false
    },
    {
      id: 'equipments',
      title: 'Equipments',
      titleKey: 'menu.items.equipments',
      type: 'item',
      icon: icons.ToolOutlined,
      url: '/spectra/equipments',
      breadcrumbs: false
    }
  ]
};

export default dashboard;

